import { isNativeApp } from 'shared/javascripts/util/detection'

// The native app still asks for education data before the sign up.
export function registrationEntryPath(returnTo: string): string {
  const path = isNativeApp() ? '/users/registration_steps/education_info' : '/users/sign_up'
  return `${path}?return_to=${encodeURIComponent(returnTo)}`
}
